export default __webpack_public_path__ + "static/media/etf_dark.a4029877.svg";